import styled from "styled-components";

const Button = ({
  children,
  width,
  transition: transitionable,
  padding,
  backgroundColor,
  font,
  border,
  isHovered,
  hover,
  radius,
  rest,
}) => {
  const classNames = {
    initialClasses: "inline-flex justify-center transition-all duration-300",
    width: width ? width : "w-auto",
    backgroundColor: backgroundColor ? backgroundColor : "bg-[#e46552]",
    font: font ? font : "text-[15px] text-white",
    border: border ? border : "border-2 border-transparent",
    hover: isHovered
      ? hover
        ? hover
        : "hover:bg-white hover:text-[#e46552] hover:border-[#e46552]"
      : "",
    padding: padding ? padding : "px-6 py-3",
    radius: radius ? radius : "rounded",
  };

  return (
    <HoveredButton
      transitionable={transitionable}
      className={`${Object.values(classNames).join(" ")}`}
      {...rest}
    >
      {children}
    </HoveredButton>
  );
};

const HoveredButton = styled.button`
  &:hover {
    transform: ${(props) =>
      props.transitionable ? "translateY(-4px);" : "translateY(0);"};
  }
`;

export default Button;
